<template>
  <div class="finish-lq">
    <div class="image-container">
      <div class="image-content">
        <div class="title">איזה כיף, עשית את הצעד הראשון בדרך לצמיחה כלכלית!</div>
        <div class="subtitle">בשלב הבא נצרף אותך לשירות ונתחיל לבנות את התזרים החודשי שלך.</div>
      </div>
      <img class="sun" :src="require('@/assets/sun.svg')">
    </div>
    <div class="button-container">
      <riseup-button class="next-question" :title="'להצטרפות לשירות'" :size="'small'" :action="gotToSignupDetails"/>
    </div>
  </div>
</template>

<script>

import BaseUI from 'base-ui';
import router from '../../../../../router';
import Segment from '../../../../../Segment';

export default {
  name: 'FinishLQ',
  components: {
    RiseupButton: BaseUI.RiseupButton,
  },
  created() {
    Segment.trackUserGot('FirstOnboardingPhaseDoneEntered');
  },
  methods: {
    gotToSignupDetails() {
      router.push({ path: '/signup/details' });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../scss/mixins';

  .finish-lq {
    @include white-page-frame;
    height: 100%;
    display: flex;
    justify-content: flex-end;

    .image-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 100%;
      height: 100%;
      background-color: #ff9129;

      .image-content {
        color: $riseup-white;
        @include responsive-padding;
        padding-top: 60px;
        text-align: center;

        .title {
          font-size: 22px;
          font-weight: bold;
          line-height: 1.27;
          margin-bottom: 20px;
        }

        .subtitle {
          font-size: 18px;
          line-height: 1.33;
        }
      }

      .sun {
        width: 100%;
      }
    }

    .button-container {
      @include responsive-padding;
      @include responsive-padding-top-bottom;
      width: 100%;

      .next-question {
        width: 100%;
        white-space: nowrap;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/non-authenticated/wine-and-dine/lead-qualification/FinishLQ.vue